module.exports = __webpack_public_path__ + "img/getstarted_pages.7c3bbfc3.gif";